//
//
//
//
//
//
//

import Home from './_home'
import TopRightShare from '@/components/views/top_right_share'
export default {
    components: {
        Home,
        TopRightShare,
    },
    onShareAppMessage () {
        return this.getShareInfo({
            title: '成都户口迁移资格查询，快来试试吧',
            path: '/pages/personal_package/verify_qualification/main'
        })
    },
    onReady () {
        const { sub_page } = this.$route.query
        if (sub_page) {
            wx.navigateTo({
                url: decodeURIComponent(sub_page)
            })
        }
    },
    methods: {
        startQuestion (type) {
            wx.navigateTo({
                url: `/pages/personal_package/verify_qualification/verify/main?type=${type}`
            })
        }
    }
}
